<div class="response table-responsive m-b-2">
    <table class="est-table building-table" cellspacing="0">
        <thead>
            <tr>
                <th>Transaction Uid</th>
                <th>Property Uid</th>
                <th>Unit Uid</th>
                <th>Entity Type</th>
                <th>Transaction Value</th>
                <th>Transaction Area (sqm)</th>
                <th>Transaction Type</th>
                <th>Date</th>
                <th>Start Date</th>
                <th>Outlier</th>
                <th>End Date</th>
            </tr>
        </thead>
        <tbody>
            @for (item of tableData; track $index) {
                <tr>
                <td>{{item.transaction_uid || '-'}}</td>
                <td>{{item.property_uid || '-'}}</td>
                <td>{{item.unit_uid || '-'}}</td>
                <td>{{item.entity_type || '-'}}</td>
                <td>{{item.transaction_value | number : "1.0-1"}}</td>
                <td>{{item.transaction_area | number : "1.0-1"}}</td>
                <td>{{item.transaction_type || '-'}}</td>
                <td>{{item.date || '-'}}</td>
                <td>{{item.start_date || '-'}}</td>
                <td>{{item.outlier || '-'}}</td>
                <td>{{item.end_date || '-'}}</td>
                </tr>
                }
        </tbody>
    </table>

</div>
<div>
    @if(response){
        <app-table-pagination [tableData]="response" [itemsPerPage]="10" (filterData)="updateRecord($event)"></app-table-pagination>
    }
</div>